import { useProjectContext } from "../context/projectsContext";
import OurOfficesIcon from "./icons/OurOffices.icon";
import ProjectImplementationIcon from "./icons/ProjectImplementation.icon";

const Projects = () => {
  const { filteredProjects, countryList, selectedCountry, setSelectedCountry } =
    useProjectContext();
  return (
    <div className="h-[50vh] md:h-full md:absolute top-0 bg-white/70 shadow-2xl shadow-slate-500/30 w-full md:w-[400px] lg:w-[500px] z-10 md:left-2/4 md:-translate-x-full md:ml-0 lg-ml-0 xl:-ml-44 bottom-0 overflow-scroll">
      <div className="p-10 w-full">
        <div className="flex justify-start items-center">
          <div className="bg-primary rounded-full w-6 h-6 align-middle mr-2"></div>
          <p className="text-lg">Project Implementation</p>
        </div>
        <div className="flex justify-start items-center mt-4">
          <div className="bg-secondary rounded-full w-6 h-6 align-middle mr-2"></div>
          <p className="text-lg">Our Offices</p>
        </div>
        <div className="mt-5 sticky top-0 bg-white py-2">
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            className="form-select form-select-lg appearance-none px-4 py-5 text-md font-normal bg-clip-padding bg-no-repeat ease-in-out m-0 focus:text-gray-700 focus:bg-white  focus:outline-none bg-gray-50 border border-slate-400 shadow-lg  shadow-slate-300/50 active:shadow-lg focus:shadow-sm text-gray-900 text-sm rounded-lg hover:border-blue-500 hover:border-2 focus:ring-blue-500 focus:border-blue-500 block w-full   transition-all duration-300 "
          >
            <option>All Countries</option>
            {countryList.map((country, i) => (
              <option key={i} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
        <div className="mt-10">
          <div className="grid grid-cols-2 gap-5">
            {typeof filteredProjects === "object" &&
              !filteredProjects.length && <div>Loading...</div>}
            {typeof filteredProjects === "object" ? (
              <>
                {filteredProjects.map((p, i) => (
                  <div key={i}>
                    <a className="hover:text-secondary" href={p.link}>
                      <div className="overflow-hidden mb-5">
                        <img
                          className="block h-40 object-cover object-center w-full rounded-md"
                          src={p.featured_image_url}
                          alt={p.title.rendered}
                          loading="lazy"
                        />
                      </div>
                      <p className="text-sm">{p.title.rendered}</p>
                    </a>
                  </div>
                ))}
              </>
            ) : (
              <div>No Projects</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
